import { render, staticRenderFns } from "./VeggieBrothRecipe.vue?vue&type=template&id=b26da986&scoped=true&"
import script from "./VeggieBrothRecipe.vue?vue&type=script&lang=js&"
export * from "./VeggieBrothRecipe.vue?vue&type=script&lang=js&"
import style0 from "./VeggieBrothRecipe.vue?vue&type=style&index=0&id=b26da986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26da986",
  null
  
)

export default component.exports